module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/BattleRoomsWrapper/images/header-cn.df72666c.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/BattleRoomsWrapper/images/header-cn.jpg
// module id = 2735
// module chunks = 11